var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.boardLanguage)?_c('v-app',{class:{ rtl: _vm.isRTL }},[_c('router-view',{attrs:{"board-language":_vm.boardLanguage},on:{"changeLanguage":_vm.changeLanguage}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }